import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import './Footer.motion.css';
import useInViewOnce from './hooks/useInViewOnce';
import { Logo } from './Navigation';
import { SOCIALS } from './profile';
import { trackEvent } from './analytics';

const Footer = ({ links }) => {
    const { t } = useTranslation();
    const footerRef = useRef(null);
    useInViewOnce(footerRef, { threshold: 0.2, rootMargin: '0px' });

    return (
        <footer className="footer" ref={footerRef}>
            <span className="footer-line" aria-hidden="true" data-inview />
            <div className="container footer-content" data-inview>
                <Logo subtitle={t('footer.role')} />

                <nav className="footer-links" aria-label={t('footer.nav')}>
                    {links.map(({ key, href }) => (
                        <a key={key} href={href}>{t(`nav.${key}`)}</a>
                    ))}
                </nav>

                <div className="footer-socials">
                    {SOCIALS.map(({ key, label, href, Icon }) => (
                        <a
                            key={key}
                            href={href}
                            className="footer-social"
                            onClick={() => trackEvent('Social Click', { network: key, location: 'footer' })}
                            aria-label={label}
                            title={label}
                            target={key === 'mail' ? undefined : '_blank'}
                            rel="noopener noreferrer"
                        >
                            <Icon size={16} />
                        </a>
                    ))}
                </div>

                <p className="footer-copy">
                    © {new Date().getFullYear()} Youssef Ben Henda. {t('footer.rights')}
                </p>
            </div>
        </footer>
    );
};

export default Footer;
